export enum EActionType {
  AddLiquidity,
  CompoundFees,
  ClaimFees,
  RebalancePosition,
  DeleveragePosition,
  ClosePosition,
}
